import { LandlordUser } from '@ui/shared/model';
import { ActionState, ActionStateCreator } from '@ui/legacy-lib';
import { CustomerImportSettings } from '../../models/customer-import-settings.model';
import { ObjectHierarchy } from '../../models/object-hierarchy.model';
import {
  CREATE_LANDLORD,
  CREATE_LANDLORD_FAIL,
  CREATE_LANDLORD_SUCCESS,
  CREATE_OBJECT_HIERARCHY_SUCCESS,
  DELETE_OBJECT_HIERARCHY_FAIL,
  DELETE_OBJECT_HIERARCHY_SUCCESS,
  GET_CUSTOMER_IMPORT_SETTINGS,
  GET_CUSTOMER_IMPORT_SETTINGS_FAIL,
  GET_CUSTOMER_IMPORT_SETTINGS_SUCCESS,
  GET_LANDLORD,
  GET_LANDLORD_FAIL,
  GET_LANDLORD_SUCCESS,
  GET_OBJECT_HIERARCHY,
  GET_OBJECT_HIERARCHY_FAIL,
  GET_OBJECT_HIERARCHY_SUCCESS,
  LandlordsAction,
  NEXT_STEP,
  PREVIOUS_STEP,
  RESET_WIZARD,
  SET_STEP,
  UPDATE_CUSTOMER_IMPORT_SETTINGS_FAIL,
  UPDATE_CUSTOMER_IMPORT_SETTINGS_SUCCESS,
  UPDATE_LANDLORD,
  UPDATE_LANDLORD_FAIL,
  UPDATE_LANDLORD_SUCCESS,
  UPDATE_OBJECT_HIERARCHY_FAIL,
  UPDATE_OBJECT_HIERARCHY_SUCCESS
} from './landlords.actions';

export interface LandlordState {
  landlord: LandlordUser;
  landlordActionState: ActionState;
  nextProductId: string;
  selectedLandlordId: string | null;
  CRUDActionState: ActionState;
  currentStepNumber: number;
  completedSteps: string[];
  objectHierarchyData: ObjectHierarchy[];
  objectHierarchyActionState: ActionState;
  customerImportSettings: CustomerImportSettings;
  customerImportSettingsActionState: ActionState;
}

export const initialState: LandlordState = {
  landlord: {},
  landlordActionState: ActionStateCreator.create(),
  nextProductId: null,
  selectedLandlordId: null,
  CRUDActionState: ActionStateCreator.create(),
  currentStepNumber: 1,
  completedSteps: [],
  objectHierarchyData: [],
  objectHierarchyActionState: ActionStateCreator.create(),
  customerImportSettings: null,
  customerImportSettingsActionState: ActionStateCreator.create()
};

export function reducer(
  state = initialState,
  action: LandlordsAction
): LandlordState {
  switch (action.type) {
    case CREATE_LANDLORD:
    case UPDATE_LANDLORD: {
      return {
        ...state,
        CRUDActionState: ActionStateCreator.onStart()
      };
    }

    case CREATE_LANDLORD_SUCCESS: {
      return {
        ...state,
        landlord: action.landlord,
        CRUDActionState: ActionStateCreator.onSuccess()
      };
    }

    case UPDATE_LANDLORD_SUCCESS: {
      return {
        ...state,
        CRUDActionState: ActionStateCreator.onSuccess(),
        landlord: action.landlord
      };
    }

    case CREATE_LANDLORD_FAIL:
    case UPDATE_LANDLORD_FAIL: {
      return {
        ...state,
        CRUDActionState: ActionStateCreator.onError(action.error)
      };
    }

    case GET_LANDLORD: {
      return {
        ...state,
        selectedLandlordId: action.id,
        landlordActionState: ActionStateCreator.onStart()
      };
    }

    case GET_LANDLORD_SUCCESS: {
      return {
        ...state,
        landlord: action.landlord,
        landlordActionState: ActionStateCreator.onSuccess()
      };
    }

    case GET_LANDLORD_FAIL: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onError(new Error(action.error))
      };
    }

    case NEXT_STEP: {
      const currentStepNumber = state.currentStepNumber + 1;
      const completedSteps = [...state.completedSteps, action.completedStep];

      return {
        ...state,
        currentStepNumber,
        completedSteps
      };
    }

    case PREVIOUS_STEP: {
      const currentStepNumber = state.currentStepNumber - 1;

      return {
        ...state,
        currentStepNumber
      };
    }

    case SET_STEP: {
      const currentStepNumber = action.currentStep;
      return {
        ...state,
        currentStepNumber
      };
    }

    case RESET_WIZARD: {
      return {
        ...initialState
      };
    }

    case GET_OBJECT_HIERARCHY: {
      return {
        ...state,
        objectHierarchyActionState: ActionStateCreator.onStart()
      };
    }

    case GET_CUSTOMER_IMPORT_SETTINGS: {
      return {
        ...state,
        customerImportSettingsActionState: ActionStateCreator.onStart()
      };
    }

    case GET_OBJECT_HIERARCHY_SUCCESS: {
      return {
        ...state,
        objectHierarchyData: action.objectHierarchy,
        objectHierarchyActionState: ActionStateCreator.onSuccess()
      };
    }

    case GET_CUSTOMER_IMPORT_SETTINGS_SUCCESS: {
      return {
        ...state,
        customerImportSettings: action.customerImportSettings,
        customerImportSettingsActionState: ActionStateCreator.onSuccess()
      };
    }

    case GET_OBJECT_HIERARCHY_FAIL:
    case UPDATE_OBJECT_HIERARCHY_FAIL:
    case DELETE_OBJECT_HIERARCHY_FAIL: {
      return {
        ...state,
        objectHierarchyActionState: ActionStateCreator.onError(action.error)
      };
    }

    case GET_CUSTOMER_IMPORT_SETTINGS_FAIL:
    case UPDATE_CUSTOMER_IMPORT_SETTINGS_FAIL: {
      return {
        ...state,
        customerImportSettingsActionState: ActionStateCreator.onError(
          action.error
        )
      };
    }

    case CREATE_OBJECT_HIERARCHY_SUCCESS:
    case DELETE_OBJECT_HIERARCHY_SUCCESS:
    case UPDATE_OBJECT_HIERARCHY_SUCCESS: {
      return {
        ...state,
        objectHierarchyActionState: ActionStateCreator.onSuccess()
      };
    }

    case UPDATE_CUSTOMER_IMPORT_SETTINGS_SUCCESS: {
      return {
        ...state,
        customerImportSettingsActionState: ActionStateCreator.onSuccess()
      };
    }

    default: {
      return state;
    }
  }
}
